import { render, staticRenderFns } from "./CardAlert.vue?vue&type=template&id=525b2f5e&scoped=true&"
import script from "./CardAlert.vue?vue&type=script&lang=js&"
export * from "./CardAlert.vue?vue&type=script&lang=js&"
import style0 from "./CardAlert.vue?vue&type=style&index=0&id=525b2f5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525b2f5e",
  null
  
)

export default component.exports